import { useCallback } from 'react';
import { useModal } from '@ebay/nice-modal-react';

import { useGetNavigationActions } from '@ocx-app/hooks/useGetNavigationActions';

import { ModalDrawer } from '@ocx/ui-modals';

import { EnterReferralCodeFormValue } from './enter-referral-code-action-sheet.types';
import { EnterReferralCodeActionSheet } from './enter-referral-code-action-sheet.component';

export const EnterReferralCodeActionSheetController = () => {
  const { visible, hide, remove } = useModal();
  const { navigateToApplyReferralCode } = useGetNavigationActions();
  const handleCompleted = useCallback(
    (values: EnterReferralCodeFormValue) => {
      hide();
      navigateToApplyReferralCode(values.code);
    },
    [hide, navigateToApplyReferralCode],
  );

  return (
    <ModalDrawer open={visible} onClose={hide} onExited={remove}>
      <EnterReferralCodeActionSheet onClose={hide} onSubmit={handleCompleted} />
    </ModalDrawer>
  );
};
